export const urls: { [k: string]: string } = {
  index: '/',

  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset/:token',
  signup: '/signup',
  profileSetup: '/profile_setup',
  sitePersonalization: '/site_personalization',
  paymentRequired: '/payment_required',
  useApp: '/use_app',
  getApp: '/get_app',

  dashboardPage: '/welcome',
};
